import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]

import { ref, computed, PropType, onBeforeUnmount } from 'vue';
import VNodeRenderer from './vnode-renderer.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-tooltip-content',
},
  __name: 'tooltip-content',
  props: {
  content: {
    type: [String, Object],
    default: '',
  },
  position: {
    type: String as PropType<'top' | 'bottom' | 'left' | 'right'>,
    default: 'top',
  },
  iconOffsetPx: {
    type: Number,
    default: 0,
  },
  wide: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {



const props = __props;

const hidden = ref(true);
const messageEl = ref<HTMLDivElement | null>(null);
const offset = ref(5);

function calculatePosition(hostPosition: DOMRect) {
  if (!messageEl.value) return;

  const tooltipPosition = messageEl.value.getBoundingClientRect();
  let top = 0;
  let left = 0;

  const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

  if (props.position === 'top') {
    top = hostPosition.top - tooltipPosition.height - offset.value - props.iconOffsetPx; // Shift up by icon offset
    left = hostPosition.left + hostPosition.width / 2 - tooltipPosition.width / 2;
  } else if (props.position === 'bottom') {
    top = hostPosition.bottom + offset.value + props.iconOffsetPx; // Shift down by icon offset
    left = hostPosition.left + hostPosition.width / 2 - tooltipPosition.width / 2;
  } else if (props.position === 'left') {
    top = hostPosition.top + (hostPosition.height - tooltipPosition.height) / 2 - props.iconOffsetPx;
    left = Math.max(hostPosition.left - tooltipPosition.width - offset.value, 0);
  } else if (props.position === 'right') {
    top = hostPosition.top + (hostPosition.height - tooltipPosition.height) / 2 - props.iconOffsetPx;
    left = hostPosition.right + offset.value;
  }

  if (messageEl.value) {
    messageEl.value.style.left = `${left}px`;
    messageEl.value.style.top = `${top + scrollPosition}px`;
  }
}

// Computed for tooltip classes
const tooltipClasses = computed(() => {
  return {
    'n-tooltip__content--top': props.position === 'top',
    'n-tooltip__content--hidden': hidden.value,
    'n-tooltip__content--bottom': props.position === 'bottom',
    'n-tooltip__content--left': props.position === 'left',
    'n-tooltip__content--right': props.position === 'right',
    'n-tooltip__content--wide': props.wide,
  };
});

const remove = () => {
  if (messageEl.value && messageEl.value.parentNode) {
    messageEl.value.parentNode.removeChild(messageEl.value);
  }
};

onBeforeUnmount(() => {
  const parent = messageEl.value?.parentNode;
  if (parent) {
    parent.removeChild(messageEl.value!);
  }
});

__expose({
  hidden,
  position: props.position,
  calculatePosition,
  remove,
  content: props.content,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-tooltip__content", tooltipClasses.value]),
    ref_key: "messageEl",
    ref: messageEl,
    "aria-hidden": hidden.value
  }, [
    _createVNode(VNodeRenderer, { nodes: __props.content }, null, 8, ["nodes"])
  ], 10, _hoisted_1))
}
}

})